import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  inject,
  input,
  signal,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DashboardLayoutService } from '../../services/dashboard-layout.service';

@Component({
  selector: 'app-dash-abschnitt',
  imports: [NgTemplateOutlet, MatIcon, TranslatePipe],
  templateUrl: './dash-abschnitt.component.html',
  styleUrl: './dash-abschnitt.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashAbschnittComponent {
  private layoutService = inject(DashboardLayoutService);
  private snackBar = inject(MatSnackBar);
  private translate = inject(TranslateService);

  readonly abschnittId = input.required<string>();
  readonly titel = input.required<string>();
  readonly first = input(false);

  protected readonly inhalt = contentChild.required(TemplateRef);

  private readonly lokal = signal<boolean | null>(null);
  private readonly key = computed(() => `dashboard.abschnitt.${this.abschnittId()}`);
  protected readonly inhaltId = computed(() => `abschnitt-${this.abschnittId()}`);
  readonly offen = computed(() => this.lokal() ?? this.layoutService.abschnittZustand(this.key()) !== 'zu');

  constructor() {
    this.layoutService.laden().pipe(takeUntilDestroyed()).subscribe();
  }

  protected umschalten(): void {
    const offen = !this.offen();
    this.lokal.set(offen);
    this.layoutService.setzeAbschnitt(this.key(), offen ? 'offen' : 'zu').subscribe({
      error: () =>
        this.snackBar.open(this.translate.instant('dashAbschnitt.saveError'), undefined, {
          panelClass: 'snackbar-error',
        }),
    });
  }
}
